/**
 * Converts camelCase to dash-case.
 *
 * For example, if you call camelToDashCase('camelCaseString'), it will return 'camel-case-string'.
 *
 * @param s camelCase string
 * @returns dash-case string
 */
export const camelToDashCase = (s: string) => s.replace(/[A-Z]/g, m => '-' + m.toLowerCase());
